import {
  // debounce, 
  Grid, Typography
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import Editor from '@ckeditor/ckeditor5-build-classic/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import CMS from '../services/db/content';

const editorConfiguration = {
  balloonToolbar: ['bold', 'italic']
};
const Conditions = () => {
  const [content, setContent] = useState({});
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    if (mounted) {
      new CMS()
        .getCMS('conditions')
        .then(r => setContent(r || {}))
        .catch(e => console.error(e))
    }
  }, [mounted]);

  const handleChange = (data) => {
    new CMS()
      .addCMS({ title: 'conditions', content: data, ...(content || {}) })
      .then(o => console.log(o))
      .catch(e => console.error(e))
  }
  return (
    <Grid xs={12} container direction='column' paddingTop={2} paddingLeft={4} minHeight='100%'>
      <Grid xs={12} paddingY={1}>
        <Typography variant='subtitle1'>Terms and conditions</Typography>
      </Grid>
      <Grid xs={12} paddingY={1}>
        <Typography variant='body2'>Content</Typography>
      </Grid>
      <Grid xs={12} container direction='column' paddingY={1} paddingLeft={5} sx={{ flex: 1 }} >
        <CKEditor
          editor={Editor}
          config={editorConfiguration}
          data={content?.content || ''}
          onReady={editor => {
            setMounted(true)
            // You can store the "editor" and use when it is needed.
            console.log('Editor is ready to use!', editor);
          }}
          onChange={(event, editor) => {
            // debounce(() => 
            handleChange(editor.getData())
            // , 3000)
            console.log(editor.getData(), event, 'hey............');
          }}
          onBlur={(event, editor) => {
            console.log('Blur.', editor, event);
          }}
          onFocus={(event, editor) => {
            console.log('Focus.', editor, event);
          }}
        />
      </Grid>
    </Grid>
  )
}

export default Conditions